import React, { useEffect } from 'react'
import Footer from '../components/Footer'
import Home from './Home/Home'
import HomeHeader from '../components/HomePageHeader'
import { withRouter } from 'react-router'
import PricingModalContent from '../components/ProPlans/PricingModalContent'
import UpgradeModal from '../components/UpgradePromoModal'
import UseCase from './UseCases/UseCase'
import ScaleCounter from './ScaleCounter/ScaleCounter'
import FAQ from './FAQ/FAQ'
import { SOURCE_HOMEPAGE } from '../constants'
import DropzoneWrapper from 'components/DragAndDrop/component/DropzoneWrapper'
import ReviewCard from '../components/ReviewCard/ReviewCard'
import Features from '../components/FeaturesBox/FeaturesBox'
import CTAButton from '../components/CTAButton/CTAButton'
import FeatureGrid from './FeatureGrid/FeatureGrid'
import GlobalTiinyReceiver from '../ClientSideAPI/TiinyWidgetReceiver'
import { DROPZONE_ACCEPTED_FILES } from '../constants'
import ExamplesSection from './ExamplesSection/ExamplesSection'
import AIPlatformBanner from '../Manage/components/AIPlatformBanner/AIPlatformBanner'

import '../App.css'

const Landing = ({ history }) => {
  useEffect(() => {
    const token = localStorage.getItem('token')

    if (token) {
      history.push('/manage' + history.location.search)
    }
  }, [])

  return (
    <DropzoneWrapper acceptedFiles={DROPZONE_ACCEPTED_FILES}>
      <GlobalTiinyReceiver />
      <div className="body-bg full-height">
        <AIPlatformBanner />
        <UpgradeModal onClick={() => history.push('/pricing')} trialAccount={true} />
        <HomeHeader />
        <Home />
        <ExamplesSection history={history} />
        <ReviewCard />
        <UseCase history={history} />
        <ScaleCounter />
        <Features />
        <FeatureGrid />
        <FAQ />
        <Footer />
      </div>
    </DropzoneWrapper>
  )
}

export default withRouter(Landing)
